import { usePrevious } from '@travelnest/merlin-hooks';
import { Button } from '@travelnest/merlin.button';
import { InputStepper } from '@travelnest/merlin.input-stepper';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { Character } from '../../../constants';
import { FormLabel, FormSelect } from '../../form';
import { Paragraph } from '../../paragraph/Paragraph';

interface IPropertyShellTypeStepProps {
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
	bedrooms: number;
	onBedroomsUpdate: (bedrooms: number) => any;
	propertyType: string;
	onPropertyTypeUpdate: (type: string) => any;
}

const propertyTypes = {
	house: 'House',
	apartment: 'Apartment',
	villa: 'Villa',
	cottage: 'Cottage',
	wigwam: 'Wigwam',
	studio: 'Studio',
	lodge: 'Lodge',
	barn: 'Barn',
	chalet: 'Chalet'
};

export const PropertyShellTypeStep: React.FC<IPropertyShellTypeStepProps> = (props) => {
	// Handle switching between studio (0 beds only) to non-studio (1+ beds only)
	const prevPropertyType = usePrevious(props.propertyType);
	React.useEffect(() => {
		if (prevPropertyType !== 'studio' && props.propertyType === 'studio') {
			props.onBedroomsUpdate(0);
		} else if (prevPropertyType === 'studio' && props.propertyType !== 'studio') {
			props.onBedroomsUpdate(1);
		}
	}, [props.propertyType]);

	const inputStepperFormatter = (val: number) => {
		if (props.propertyType === 'studio' && val === 0) {
			return '0 bedroom studio';
		} else if (val === 1) {
			return `1 bedroom`;
		}
		return `${val} bedrooms`;
	};

	return <Modal
		title="Add a new property"
		onRequestClose={props.onRequestClose}
		shouldCloseOnOverlayClick={false}
		actionLHS={
			<Button
				onClick={props.onRequestPrevious}
				bgColor={theme.colours.background.default}
				color={theme.colours.text.black}
				className="travelnest-modal__button-align"
			>
				<span className="travelnest-modal__icon">{Character.Left}</span>
				<span>Previous</span>
			</Button>
		}
		actionRHS={
			<Button
				onClick={props.onRequestNext}
				bgColor={theme.colours.success.primary}
				color={theme.colours.text.white}
				hoverColor={theme.colours.success.primary}
				className="travelnest-modal__button-align"
			>
				<span>Next</span>
				<span className="travelnest-modal__icon">{Character.Right}</span>
			</Button>}>
		<div>
			<Paragraph>Which of these property types is the closest match to your property?</Paragraph>
			<FormLabel htmlFor="property_shell_type_select">Property Type</FormLabel>
			<FormSelect id="property_shell_type_select" onChange={(el) => props.onPropertyTypeUpdate(el.target.value)} defaultValue={props.propertyType}>
				{Object.entries(propertyTypes).map((pair) => <option key={pair[0]} value={pair[0]}>{pair[1]}</option>)}
			</FormSelect>
			<Paragraph>How many bedrooms does your property have?</Paragraph>
			<InputStepper
				id="property_shell_type_stepper"
				minValue={props.propertyType === 'studio' ? 0 : 1}
				maxValue={props.propertyType === 'studio' ? 0 : undefined}
				value={props.bedrooms}
				valueFormatter={inputStepperFormatter}
				onClick={(val) => props.onBedroomsUpdate(val)}
			/>
		</div>
	</Modal>;
};
